export const AMPLITUDE_API_KEY = '07930192a735da43e5c773d38cdb6bb3';
export const AMPLITUDE_SECRET_KEY = '92e861af64ec770de076d60051229260';
